import AgentsRegionPage from 'sly/agentsRegionPage';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default AgentsRegionPage;

export async function getServerSideProps({
  params,
}: {
  params: { region: string };
}) {
  const { api, store } = createApiClient(apiEndpoints);

  try {
    await store.dispatch(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      api.getAgentsNew.asAction({
        'filter[region]': params.region,
        'filter[status]': 'gt:0',
        include: 'address,gallery,gallery.images',
        'page-size': 100,
      })
    );
  } catch (e) {
    console.error(e);

    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
